// ---------------------------------------------------------------------------
// Bare icon names used to be Lucide (e.g. "Trash2"); they are now Phosphor
// duotone. Saved data (menus, workpages, forms, workflow buttons) still holds
// Lucide names, so this table translates them to the closest Phosphor icon.
// Names both libraries share ("Plus", "Eye") need no entry.
// ---------------------------------------------------------------------------

export const LUCIDE_TO_PHOSPHOR: Record<string, string> = {
  AlertCircle: 'WarningCircle',
  AlertTriangle: 'Warning',
  ArrowDownToLine: 'ArrowLineDown',
  ArrowLeftRight: 'ArrowsLeftRight',
  ArrowUpToLine: 'ArrowLineUp',
  Badge: 'Seal',
  Ban: 'Prohibit',
  BarChart: 'ChartBar',
  BarChart3: 'ChartBar',
  Bold: 'TextB',
  Bot: 'Robot',
  Box: 'Package',
  Boxes: 'Cube',
  Braces: 'BracketsCurly',
  Brush: 'PaintBrush',
  Building2: 'Buildings',
  CalendarClock: 'CalendarDots',
  CarFront: 'Car',
  CaseSensitive: 'TextAa',
  CheckCircle2: 'CheckCircle',
  ChevronDown: 'CaretDown',
  ChevronLeft: 'CaretLeft',
  ChevronRight: 'CaretRight',
  ChevronUp: 'CaretUp',
  ChevronsLeft: 'CaretDoubleLeft',
  ChevronsRight: 'CaretDoubleRight',
  CircleAlert: 'WarningCircle',
  CircleCheck: 'CheckCircle',
  CircleDot: 'RadioButton',
  CirclePlus: 'PlusCircle',
  CircleQuestionMark: 'Question',
  CircleX: 'XCircle',
  ClipboardEdit: 'ClipboardText',
  ClipboardList: 'ClipboardText',
  ClockFading: 'ClockCountdown',
  Code2: 'Code',
  Columns3: 'Columns',
  Columns3Cog: 'Columns',
  Contact: 'AddressBook',
  Container: 'Package',
  Currency: 'CurrencyDollar',
  Delete: 'Backspace',
  Dices: 'DiceFive',
  Diff: 'GitDiff',
  DollarSign: 'CurrencyDollar',
  Edit: 'PencilSimple',
  Ellipsis: 'DotsThree',
  Expand: 'ArrowsOut',
  ExternalLink: 'ArrowSquareOut',
  EyeOff: 'EyeSlash',
  FileEdit: 'NotePencil',
  FileInput: 'FileArrowUp',
  FileOutput: 'FileArrowDown',
  FilePenLine: 'NotePencil',
  FilePlus2: 'FilePlus',
  FileSpreadsheet: 'FileXls',
  Filter: 'Funnel',
  FlaskConical: 'Flask',
  Forward: 'ArrowBendUpRight',
  GitCompare: 'GitDiff',
  Grid3x3: 'GridNine',
  Grip: 'DotsNine',
  GripVertical: 'DotsSixVertical',
  Group: 'BoundingBox',
  HatGlasses: 'Detective',
  HelpCircle: 'Question',
  History: 'ClockCounterClockwise',
  Home: 'House',
  IdCard: 'IdentificationCard',
  Import: 'DownloadSimple',
  Inbox: 'Tray',
  Inspect: 'MagnifyingGlass',
  Italic: 'TextItalic',
  KeyRound: 'Key',
  Landmark: 'Bank',
  Languages: 'Translate',
  LayoutDashboard: 'SquaresFour',
  LayoutGrid: 'SquaresFour',
  LayoutPanelTop: 'Layout',
  LayoutTemplate: 'Layout',
  LineChart: 'ChartLine',
  ListCheck: 'ListChecks',
  ListOrdered: 'ListNumbers',
  Loader: 'Spinner',
  Loader2: 'CircleNotch',
  LoaderCircle: 'CircleNotch',
  LocateFixed: 'GpsFix',
  LockKeyhole: 'LockKey',
  LogIn: 'SignIn',
  LogOut: 'SignOut',
  ListTree: 'TreeView',
  Logs: 'ListBullets',
  Mail: 'Envelope',
  MailCheck: 'EnvelopeSimpleOpen',
  MailOpen: 'EnvelopeOpen',
  Maximize2: 'ArrowsOut',
  Menu: 'List',
  MessageSquare: 'ChatCentered',
  Minimize2: 'ArrowsIn',
  MousePointerClick: 'CursorClick',
  PanelTop: 'Browser',
  RectangleEllipsis: 'Password',
  Redo: 'ArrowClockwise',
  Redo2: 'ArrowUUpRight',
  RemoveFormatting: 'TextTSlash',
  Reply: 'ArrowBendUpLeft',
  RotateCcw: 'ArrowCounterClockwise',
  Save: 'FloppyDisk',
  ScanText: 'Scan',
  Search: 'MagnifyingGlass',
  Section: 'Paragraph',
  Send: 'PaperPlaneRight',
  Settings: 'Gear',
  Settings2: 'Sliders',
  Share2: 'ShareNetwork',
  ShieldAlert: 'ShieldWarning',
  SlidersVertical: 'Sliders',
  Split: 'ArrowsSplit',
  SquareCheck: 'CheckSquare',
  SquareMenu: 'ListDashes',
  SquareMinus: 'MinusSquare',
  SquarePen: 'NotePencil',
  StickyNote: 'Note',
  Summary: 'Article',
  Table2: 'Table',
  TableCellsMerge: 'Table',
  Tags: 'Tag',
  Text: 'TextAlignLeft',
  TextCursor: 'CursorText',
  Tickets: 'Ticket',
  TimerOff: 'Timer',
  Trash2: 'Trash',
  TrendingUp: 'TrendUp',
  TriangleAlert: 'Warning',
  Type: 'TextT',
  Undo: 'ArrowCounterClockwise',
  Undo2: 'ArrowUUpLeft',
  UploadCloud: 'CloudArrowUp',
  UserCog: 'UserGear',
  UserX: 'UserMinus',
  VectorSquare: 'BoundingBox',
  View: 'Eye',
  Wand2: 'MagicWand',
  Workflow: 'FlowArrow',
  Zap: 'Lightning',
};
